import { API_URL, API_ZONESSECONDARY } from "../ApiPaths";

/** TEAM */
export const getZonesSecondary = async () => {
  const res = await fetch(API_URL + API_ZONESSECONDARY, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Network response was not ok");
  }
  return res.json();
};

export const addNewZoneSecondary = async (tmpNew: string) => {
  const res = await fetch(API_URL + API_ZONESSECONDARY, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name: tmpNew }),
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }

  return res.json();
};

export const deleteZoneSecondary = async (id: string) => {
  const res = await fetch(`${API_URL}${API_ZONESSECONDARY}/${id}`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }

  return res.json();
};
